import { SLPLQTypes } from './questions/questionsTypes/questionsTypes.lang';
export const SLPLang = {
    questionsTypes: SLPLQTypes,
    loading: 'در حال بارگذاری، لطفا صبور باشید',
    start: 'شروع',
    startEN: 'Start',
    thanks: 'از اینکه ما را از نظرات ارزشمند خود بهره مند میکنید سپاسگذاریم.',
    startAgain: 'شروع مجدد',
    startAgainEN: 'Start Again',
    createTxt: 'برای ساخت رایگان فرم، کلیک کنید!',
    createTxtEN: 'Click to create new form!',
    create: 'ساخت فرم جدید',
    createEN: 'Create New Form',
    title: 'عنوان صفحه: ',
    titleEn: 'Page name:  ',
    next: 'بعدی',
    nextEN: 'next',
    previous: 'قبلی',
    previousEN: 'previous',
    nextPage: 'صفحه بعد',
    nextPageEN: 'next page',
    previousPage: 'صفحه قبل',
    previousPageEN: 'previous page',
    finish: 'پایان',
    finishEN: 'finish',
    cancel: 'انصراف',
    cancelEN: 'cancel',
    back: 'بازگشت',
    password: 'کلمه عبور',
    endDescription:
        'شما نیز می توانید، به صورت کاملا رایگان فرم های پرسشنامه و  نظرسنجی خود را ایجاد و یا از نمونه های استاندارد  ما در یوچک استفاده کنید. ',
    tanks: 'با تشکر از شما',
    premium: 'جهت عدم نمایش تبلیغات حساب خود را به نسخه بالاتر ارتقا دهید',
    logout: 'خروج',
    kioskLogout: 'کد اتصال خود را جهت خروج از حساب کاربری وارد کنید',
    wrongCodeErr: 'کد وارد شده با کد اتصال این انتشار مغایر است. لطفا کد دیگری وارد کنید',
    errorCodes: {
        disableForm: 'فرم مورد نظر غیرفعال می‌باشد  و دسترسی به آن امکان پذیر نیست.',
        brokenPublish: 'انتشار مورد نظرتان برای این فرم در دسترس نیست',
        noPublish: 'انتشار مورد نظرتان برای این فرم در دسترس نیست',
        invalidPassword: 'رمز عبور وارد شده صحیح نیست. لطفا مجددا تلاش کنید',
        passwordRequired: 'کلمه عبور خود را وارد کنید',
        sourceUnique: 'لینک مورد نظر شما منقضی شده و دسترسی به آن امکان پذیر نیست',
        invalidSource: 'منبعی که از آن وارد شده اید معتبر نیست',
        parameterUnique: 'لینک مورد نظر شما منقضی شده و دسترسی به آن امکان پذیر نیست',
        parameterDatalistUnique: 'پارامتر احراز هویت شما منقضی شده و دسترسی به آن امکان پذیر نیست',
        invalidParameter: 'پارامتر لینک فرم معتبر نیست.',
        invalid: 'لینک مورد نظر معتبر نیست',
    },
};
